// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"111":"02a4e9ea","958":"5b93eb66"}[chunkId] + ".chunk.js";
};